import React, {forwardRef} from 'react';

import {AppContext} from '../../AppModule/Context';
import {ROOT} from '../../components/expertDashboardModule/expertSettingsComponent/leftNavigationData';

import expertHomeService from '../../services/expertHomeService';
import navigationService from '../../services/navigationService';
import storageService from '../../services/storageService';
import VIDABOO_CONSTANTS from '../../config/consts';

export const ThisContext = React.createContext();

class ExpertHomeContextProvider extends React.Component {
  constructor() {
    super();
    this.state = {
      privateChatRoomDto: {},
      chatRoomIdOfActiveCall: null,
      userProfilePhotoUrl: null,
      accountProfilePhotoUrl: null,
      widgetDtos: null, // [widgetDto1, widgetDto2]
      selectedMentorDtos: null, // {{mentorId1: widgetDto1}, {mentorId2: widgetDto2}}
      rootNavElement: ROOT,
      activeNavElement: null,
      // Generic navigation elements - can be used for any navigation structure
      // Structure: { navigationKey: { rootNavElement, activeNavElement } }
      genericNavigationData: {},
      showMentorPills: JSON.parse(
        storageService.getItem(
          VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.MENTOR_PILLS_VISIBLE,
        ) ?? true,
      ),
      showWidgetSelectorDD: false,
      backOfficeConfiguration: null,
      expertSettingsTabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.AGENT,
      avoidFrillAutoload: false,
      showFullBackOfficeSettingsBtn: false,
      activeTourComponent: null,
      marketingElementsStatus:
        expertHomeService.createNewMarketingElementsStatus(),
      nativeFlagWidgetVisibilityType:
        VIDABOO_CONSTANTS.NATIVE_FLAG_WIDGET_VISIBILITY_TYPES.BOTTOM_RIGHT,
      emailCustomizationUiData: null,
    };
  }

  setAvoidFrillAutoload = (avoidFrillAutoload) => {
    this.setState({avoidFrillAutoload});
  };
  setActiveTourComponent = (activeTourComponent) => {
    this.setState({activeTourComponent});
  };
  setEmailCustomizationUiData = (emailCustomizationUiData) => {
    this.setState({emailCustomizationUiData});
  };
  setMarketingElementsStatus = (marketingElementType, newStatus) => {
    const marketingElementsStatus = {...this.state.marketingElementsStatus};
    marketingElementsStatus[marketingElementType] = newStatus;
    this.setState({marketingElementsStatus});
  };
  setPrivateChatRoomDto = (privateChatRoomDto) => {
    this.setState({privateChatRoomDto});
  };
  setChatRoomIdOfActiveCall = (chatRoomIdOfActiveCall) => {
    this.setState({chatRoomIdOfActiveCall});
  };

  setUserProfilePhotoUrl = (userProfilePhotoUrl) => {
    this.setState({userProfilePhotoUrl});
  };

  setAccountProfilePhotoUrl = (accountProfilePhotoUrl) => {
    this.setState({accountProfilePhotoUrl});
  };

  setWidgetDtos = (widgetDtos) => {
    this.setState({widgetDtos});
  };

  setSelectedMentorDtos = (selectedMentorDtos) => {
    this.setState({selectedMentorDtos});
  };

  setActiveNavElement = (activeNavElement) => {
    this.setState({activeNavElement});
  };

  setGenericNavigationData = (navigationKey, data) => {
    this.setState({
      genericNavigationData: {
        ...this.state.genericNavigationData,
        [navigationKey]: data,
      },
    });
  };

  setNativeFlagWidgetVisibility = (visibilityType) =>
    this.setState({nativeFlagWidgetVisibilityType: visibilityType});

  getFirstMentorDtoByWidgetAndUserId = (widgetId, userId) => {
    const widgetDto = this.getWidgetDtoByWidgetId(widgetId);

    return Object.values(widgetDto?.mentorsControlMapDto ?? {}).find(
      (widgetMentorCtrlDto) =>
        widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
        userId,
    );
  };

  getFirstSelectedMentorDtoByWidgetAndUserId = (widgetId, userId) => {
    const widgetDto = this.getWidgetDtoByWidgetId(widgetId);

    return Object.values(widgetDto?.mentorsControlMapDto ?? {}).find(
      (widgetMentorCtrlDto) =>
        widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorOwnerId ===
          userId &&
        this.state.selectedMentorDtos[
          widgetMentorCtrlDto.extendedMentorDto.mentorDto.mentorId
        ],
    );
  };

  getFirstSelectedWidgetMentorCtrlDtoUsingUserId = (userId) => {
    let widgetMentorCtrlDto = null;
    for (const mentorId in this.state.selectedMentorDtos ?? {}) {
      if (
        !widgetMentorCtrlDto &&
        this.state.selectedMentorDtos[mentorId].mentorsControlMapDto[mentorId]
          ?.extendedMentorDto.mentorDto.mentorOwnerId === userId
      ) {
        widgetMentorCtrlDto =
          this.state.selectedMentorDtos[mentorId].mentorsControlMapDto[
            mentorId
          ];
      }
    }
    return widgetMentorCtrlDto;
  };

  getSelectedMentorDto = () => {
    const mentorId = Object.keys(this.state.selectedMentorDtos || {})[0];
    if (mentorId) {
      return this.state.selectedMentorDtos[mentorId]?.mentorsControlMapDto[
        mentorId
      ]?.extendedMentorDto?.mentorDto;
    } else {
      return null;
    }
  };

  getSelectedWidgetDto = () => {
    return Object.values(this.state.selectedMentorDtos || {})[0];
  };

  getWidgetDtoByMentorId = (mentorId) => {
    let result = {};
    this.state.widgetDtos?.forEach((widgetDto) => {
      if (widgetDto.mentorsControlMapDto[mentorId]) {
        result = widgetDto;
      }
    });
    return result;
  };

  getWidgetDtoByTeamMentorId = (teamMentorId) => {
    let result = {};
    this.state.widgetDtos?.forEach((widgetDto) => {
      if (widgetDto.teamMentorsMapDto[teamMentorId]) {
        result = widgetDto;
      }
    });
    return result;
  };

  getSelectedWidgetMentorCtrlDto = () => {
    const mentorId = Object.keys(this.state.selectedMentorDtos || {})[0];
    if (mentorId) {
      return this.state.selectedMentorDtos[mentorId].mentorsControlMapDto[
        mentorId
      ];
    } else {
      return null;
    }
  };

  getUnAuthorizedUserDtos = (usersCtrlMap) => {
    let userDtos = [];
    const selectedMentorDtos = this.state.selectedMentorDtos || {};
    for (const mentorId in selectedMentorDtos) {
      if (
        selectedMentorDtos[mentorId].mentorsControlMapDto[mentorId]
          .extendedMentorDto.privateDataConsentStatus ===
        VIDABOO_CONSTANTS.PRIVATE_DATA_ACCESS_STATES.REQUEST
      ) {
        const userDto =
          usersCtrlMap[
            selectedMentorDtos[mentorId].mentorsControlMapDto[mentorId]
              .extendedMentorDto.mentorDto.mentorOwnerId
          ]?.userDto;
        if (userDto && !userDtos.includes(userDto)) {
          userDtos.push(userDto);
        }
      }
    }
    return userDtos;
  };

  setRootNavElement = (rootNavElement) => {
    this.setState({rootNavElement});
    navigationService.setRootNavElement(this.setRootNavElement);
  };

  setShowMentorPills = (showMentorPills) => {
    this.setState({showMentorPills});
  };

  setShowWidgetSelectorDD = (showWidgetSelectorDD) => {
    this.setState({showWidgetSelectorDD});
  };

  setBackOfficeConfiguration = (backOfficeConfiguration) => {
    this.setState({backOfficeConfiguration});
  };

  setShowFullBackOfficeSettingsBtn = (showFullBackOfficeSettingsBtn) => {
    this.setState({showFullBackOfficeSettingsBtn});
  };

  setExpertSettingsTabMode = (expertSettingsTabMode) => {
    this.setState({expertSettingsTabMode});
  };

  setActiveNavElementByUrl = (url) => {
    const navElement = navigationService.getNavElementUsingUrl(url);
    if (navElement) {
      if (navElement.tabMode) {
        this.setExpertSettingsTabMode(navElement.tabMode);
      }
      this.setActiveNavElement(navElement);
    }
  };

  resetExpertHomeContextAndRootNav = () => {
    const navData = [
      {
        url: 'home',
        isViewable: true,
      },
      {
        url: 'widgetSetup',
        isViewable: true,
      },
      {
        url: 'personalSettings',
        isViewable: true,
      },
      {
        url: 'accountSettings',
        isViewable: true,
      },
      {
        url: 'settingsShortcuts',
        isViewable: true,
      },
    ];
    navigationService.updateNavElementsIsViewable(navData);
    //eslint-disable-next-line react/no-direct-mutation-state
    this.setState({
      privateChatRoomDto: {},
      chatRoomIdOfActiveCall: null,
      userProfilePhotoUrl: null,
      accountProfilePhotoUrl: null,
      widgetDtos: null,
      selectedMentorDtos: null,
      rootNavElement: null,
      activeNavElement: null,
      showMentorPills: false,
      showWidgetSelectorDD: false,
      backOfficeConfiguration: null,
      expertSettingsTabMode: VIDABOO_CONSTANTS.EXPERT_SETTINGS_TAB_MODES.WIDGET,
      avoidFrillAutoload: false,
      activeTourComponent: false,
      setMarketingElementsStatus:
        expertHomeService.createNewMarketingElementsStatus(),
    });
  };

  updateDataWhenWidgetDtosChanged = (updatedWidgetDtos) => {
    //this updates the widgetDto of selectedMentorDtos of expertHomeContext whenever there is change in widgetDtos (for eg due to API)
    let tmpSelectedMentorDtosObj = JSON.parse(
      JSON.stringify(this.state.selectedMentorDtos || {}),
    );

    ({updatedWidgetDtos, tmpSelectedMentorDtosObj} =
      expertHomeService.updateDataWhenWidgetDtosChanged(
        updatedWidgetDtos,
        tmpSelectedMentorDtosObj,
        this.context.getAccountDto(),
        this.context.getCurrentUser().userId,
      ));

    // we need to update selectedMentorDtos in few cases like:
    // 1. when account admin deletes the mentor which was selected by team admin in his account. But after deletion it doesn't exist anymore so we need to update the selectedMentorDtos
    // 2. if widgetPrivacyMode is changed (currently team mentor was selected and mentor moved to FULLY PRIVATE)
    const selectedMentorDto = expertHomeService.getSelectedMentorDto(
      tmpSelectedMentorDtosObj,
    );
    const selectedWidgetDto = expertHomeService.getSelectedWidgetDto(
      tmpSelectedMentorDtosObj,
    );
    if (
      selectedMentorDto.mentorOwnerType ===
        VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET &&
      selectedWidgetDto.widgetAppCtrlDto?.widgetPrivacyMode ===
        VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.FULLY_PRIVATE
    ) {
      delete tmpSelectedMentorDtosObj[selectedMentorDto.mentorId];
    }
    if (Object.keys(tmpSelectedMentorDtosObj).length === 0) {
      const defaultSelectedMentorId = Object.keys(
        updatedWidgetDtos[0].mentorsControlMapDto ??
          updatedWidgetDtos[0].teamMentorsMapDto,
      )[0];
      tmpSelectedMentorDtosObj[defaultSelectedMentorId] = updatedWidgetDtos[0];
    }

    this.setWidgetAndSelectedMentorDtos(
      updatedWidgetDtos,
      tmpSelectedMentorDtosObj,
    );
  };

  updateDataWhenSelectedMentorDtosChanged = (updatedSelectedMentorDtosObj) => {
    //this updates the widgetDtos of expertHomeContext whenever there is change in selectedMentorDtos (for eg due to API)
    let tmpWidgetDtosArr = JSON.parse(
      JSON.stringify(this.state.widgetDtos || []),
    );

    // Group mentors by widget to avoid overwriting changes when multiple mentors from same widget are updated
    const widgetUpdatesMap = {};

    Object.entries(updatedSelectedMentorDtosObj).forEach(
      ([mentorId, updatedWidgetDto]) => {
        const widgetId = updatedWidgetDto.widgetId;

        if (!widgetUpdatesMap[widgetId]) {
          // Find the current widget DTO in the array
          const currentWidgetIndex = tmpWidgetDtosArr.findIndex(
            (wDto) => wDto.widgetId === widgetId,
          );

          if (currentWidgetIndex !== -1) {
            // Start with a copy of the current widget
            widgetUpdatesMap[widgetId] = {
              index: currentWidgetIndex,
              widgetDto: JSON.parse(
                JSON.stringify(tmpWidgetDtosArr[currentWidgetIndex]),
              ),
            };
          }
        }

        // Apply mentor-specific updates to the widget
        if (widgetUpdatesMap[widgetId]) {
          const widget = widgetUpdatesMap[widgetId].widgetDto;

          // Update mentor in mentorsControlMapDto if it exists
          if (
            updatedWidgetDto.mentorsControlMapDto &&
            updatedWidgetDto.mentorsControlMapDto[mentorId]
          ) {
            if (!widget.mentorsControlMapDto) {
              widget.mentorsControlMapDto = {};
            }
            widget.mentorsControlMapDto[mentorId] =
              updatedWidgetDto.mentorsControlMapDto[mentorId];
          }

          // Update mentor in teamMentorsMapDto if it exists
          if (
            updatedWidgetDto.teamMentorsMapDto &&
            updatedWidgetDto.teamMentorsMapDto[mentorId]
          ) {
            if (!widget.teamMentorsMapDto) {
              widget.teamMentorsMapDto = {};
            }
            widget.teamMentorsMapDto[mentorId] =
              updatedWidgetDto.teamMentorsMapDto[mentorId];
          }
        }
      },
    );

    // Apply all widget updates
    Object.values(widgetUpdatesMap).forEach(({index, widgetDto}) => {
      tmpWidgetDtosArr[index] = widgetDto;
    });

    expertHomeService.addDefaultValuesToWidgetDtos(
      this.context.getAccountDto(),
      tmpWidgetDtosArr,
      this.context.getCurrentUser().userId,
    );

    this.setWidgetAndSelectedMentorDtos(
      tmpWidgetDtosArr,
      updatedSelectedMentorDtosObj,
    );
  };

  setWidgetAndSelectedMentorDtos = (widgetDtos, selectedMentorDtos) => {
    this.setState({
      widgetDtos,
      selectedMentorDtos,
    });
  };

  render() {
    let {
      state: {
        nativeFlagWidgetVisibilityType,
        activeNavElement,
        privateChatRoomDto,
        chatRoomIdOfActiveCall,
        rootNavElement,
        genericNavigationData,
        selectedMentorDtos,
        userProfilePhotoUrl,
        accountProfilePhotoUrl,
        widgetDtos,
        showMentorPills,
        showWidgetSelectorDD,
        backOfficeConfiguration,
        expertSettingsTabMode,
        avoidFrillAutoload,
        showFullBackOfficeSettingsBtn,
        activeTourComponent,
        marketingElementsStatus,
        emailCustomizationUiData,
      },
      setActiveNavElement,
      setPrivateChatRoomDto,
      setChatRoomIdOfActiveCall,
      setGenericNavigationData,
      setRootNavElement,
      setSelectedMentorDtos,
      setUserProfilePhotoUrl,
      setAccountProfilePhotoUrl,
      setWidgetDtos,
      setShowMentorPills,
      setShowWidgetSelectorDD,
      setBackOfficeConfiguration,
      setExpertSettingsTabMode,
      setActiveNavElementByUrl,
      setNativeFlagWidgetVisibility,
      resetExpertHomeContextAndRootNav,
      setAvoidFrillAutoload,
      setShowFullBackOfficeSettingsBtn,
      setActiveTourComponent,
      setMarketingElementsStatus,
      updateDataWhenSelectedMentorDtosChanged,
      updateDataWhenWidgetDtosChanged,
      setEmailCustomizationUiData,
    } = this;

    return (
      <ThisContext.Provider
        value={{
          nativeFlagWidgetVisibilityType,
          activeNavElement,
          privateChatRoomDto,
          chatRoomIdOfActiveCall,
          genericNavigationData,
          rootNavElement,
          selectedMentorDtos, // [{mentorId: widgetDto}]
          userProfilePhotoUrl,
          accountProfilePhotoUrl,
          widgetDtos,
          showMentorPills,
          showWidgetSelectorDD,
          backOfficeConfiguration,
          expertSettingsTabMode,
          avoidFrillAutoload,
          showFullBackOfficeSettingsBtn,
          activeTourComponent,
          marketingElementsStatus,
          emailCustomizationUiData,
          setActiveNavElement,
          setGenericNavigationData,
          setPrivateChatRoomDto,
          setChatRoomIdOfActiveCall,
          setRootNavElement,
          setSelectedMentorDtos,
          setUserProfilePhotoUrl,
          setAccountProfilePhotoUrl,
          setWidgetDtos,
          setShowMentorPills,
          setShowWidgetSelectorDD,
          setBackOfficeConfiguration,
          setExpertSettingsTabMode,
          setActiveNavElementByUrl,
          resetExpertHomeContextAndRootNav,
          setAvoidFrillAutoload,
          setShowFullBackOfficeSettingsBtn,
          setActiveTourComponent,
          setMarketingElementsStatus,
          setNativeFlagWidgetVisibility,
          updateDataWhenSelectedMentorDtosChanged,
          updateDataWhenWidgetDtosChanged,
          setEmailCustomizationUiData,
        }}>
        {this.props.children}
      </ThisContext.Provider>
    );
  }
}

ExpertHomeContextProvider.contextType = AppContext;
export default ExpertHomeContextProvider;

export const withExpertHomeContext = (Component) =>
  //eslint-disable-next-line react/display-name
  forwardRef((props, ref) => (
    <ThisContext.Consumer>
      {(context) => (
        <Component expertHomeContext={context} {...props} ref={ref} />
      )}
    </ThisContext.Consumer>
  ));
